// Seamless 512² fractal-noise water tile, baked once and fed to PixiRenderer as the ocean texture.
// Ported unchanged in character from the arena renderer: four value-noise octaves, each periodic on its
// own exact span, so the tile wraps without seams; deep-blue body, lighter swell tops, faint crest foam.

const S = 512, L = 192;

function clamp01(v: number): number { return v < 0 ? 0 : v > 1 ? 1 : v; }

export function makeOceanTile(): HTMLCanvasElement {
  let seed = 88675123;
  const rnd = () => { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; };
  const lat = new Float32Array(L * L);
  for (let i = 0; i < L * L; i++) lat[i] = rnd();
  // value noise, periodic with period p on both axes
  const val = (x: number, y: number, p: number) => {
    const xi = Math.floor(x), yi = Math.floor(y), fx = x - xi, fy = y - yi;
    const sx = fx * fx * (3 - 2 * fx), sy = fy * fy * (3 - 2 * fy);
    const x0 = xi % p, x1 = (xi + 1) % p, y0 = (yi % p) * L, y1 = ((yi + 1) % p) * L;
    return (lat[y0 + x0] * (1 - sx) + lat[y0 + x1] * sx) * (1 - sy) + (lat[y1 + x0] * (1 - sx) + lat[y1 + x1] * sx) * sy;
  };
  const cv = document.createElement('canvas');
  cv.width = cv.height = S;
  const c = cv.getContext('2d');
  if (!c) return cv;
  const img = c.createImageData(S, S), d = img.data;
  for (let py = 0; py < S; py++) {
    for (let px = 0; px < S; px++) {
      let h = 0.52 * val((px / S) * 24, (py / S) * 24, 24)
            + 0.27 * val((px / S) * 48, (py / S) * 48, 48)
            + 0.14 * val((px / S) * 96, (py / S) * 96, 96)
            + 0.07 * val((px / S) * 192, (py / S) * 192, 192);
      h = clamp01((h - 0.18) * 1.5);
      const crest = h > 0.74 ? Math.pow((h - 0.74) / 0.26, 1.5) : 0;
      const i = (py * S + px) * 4;
      d[i] = 10 + h * 40 + crest * 130;
      d[i + 1] = 34 + h * 62 + crest * 140;
      d[i + 2] = 62 + h * 82 + crest * 120;
      d[i + 3] = 255;
    }
  }
  c.putImageData(img, 0, 0);
  return cv;
}
